module.exports = __webpack_public_path__ + "img/SKMA_light.c492ad25.png";